import React, { useEffect, useState } from 'react'
import { DatePicker, Select, Table, Button, Space } from 'antd'
import dayjs from 'dayjs'
import axios from 'axios'
import {
  GetEventMaster,
  GetStudentListForEventAttendance,
  SaveStudentEventAttendance,
} from '../../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'
import '../Masters/MasterCSS.css'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import * as XLSX from 'xlsx'

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

const { Option } = Select

export default function StudentEventAttendance() {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [date, setDate] = useState(dayjs())
  const [eventId, setEventId] = useState('')
  const [eventList, setEventList] = useState([])

  const [studentList, setStudentList] = useState([])
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)

  const [saveDisabled, setSaveDisabled] = useState(false);
  
  
    useEffect(() => {
    setSaveDisabled(false);
  }, [date]);

  // ---------------------------------------------------
  // 1️⃣ FETCH EVENTS FOR SELECTED DATE
  // ---------------------------------------------------
  const fetchEvents = async () => {
    try {
      const res = await axios.get(
        `${GetEventMaster}/${storedBranchId}/${BoardingYear}`,
      )

      const eventData = res.data || []

      // 👉 Filter events matching selected date
      const filtered = eventData.filter((e) =>
        dayjs(e.event_date).isSame(date, 'day'),
      )

      setEventList(filtered)
      setEventId('') // reset dropdown
      setStudentList([]) // clear table
    } catch (e) {
      console.error(e)
      toast.error('Failed to load events')
    }
  }

  // ---------------------------------------------------
  // 2️⃣ FETCH STUDENTS FOR DATE + EVENT
  // ---------------------------------------------------
  const fetchStudents = async () => {
    if (!eventId) return

    setLoading(true)

    try {
      const res = await axios.get(
        `${GetStudentListForEventAttendance}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data?.map((item) => {
        // Find attendance for selected event + date
        const attendance = item.event_attendances?.find(
          (att) =>
            att.event_id === Number(eventId) &&
            dayjs(att.attendance_date).isSame(date, 'day'),
        )

        // Find leave for this date
        // const leave = item.leaves?.find(
        //   (l) =>
        //     dayjs(l.from_date).isSame(date, "day") &&
        //     dayjs(l.to_date).isSame(date, "day") &&
        //     l.status == 2
        // );

        const leave = item.leaves?.find(
          (l) =>
            l.status === 2 &&
            dayjs(date).isSameOrAfter(dayjs(l.from_date), 'day') &&
            dayjs(date).isSameOrBefore(dayjs(l.to_date), 'day'),
        )

        let statusflag = '0'
        let disabledRow = false

        if (attendance) {
          statusflag = attendance.status.toString() // ✔ Convert to string
          disabledRow = true
        }
        // 2️⃣ If leave exists and status == 2 → Absent
        if (leave) {
          statusflag = leave.status.toString() // Absent
          disabledRow = true // Also lock row
        }

        return {
          reg_id: item.reg_id,
          full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
          room: item?.roombooking?.room?.room_no,
          bed: item?.roombooking?.bed?.bed_no,
          statusflag,
          disabledRow,
        }
      })

      setStudentList(formatted)
    } catch (e) {
      console.error(e)
      toast.error('Failed to load student attendance')
    }

    setLoading(false)
  }

  // Trigger event fetch when date changes
  useEffect(() => {
    fetchEvents()
  }, [date])

  // Trigger student fetch when event changes
  useEffect(() => {
    if (eventId !== '') {
      fetchStudents()
    }
  }, [eventId])

  // ---------------------------------------------------
  // 3️⃣ UPDATE SINGLE STUDENT STATUS
  // ---------------------------------------------------
  const updateStatus = (id, flag) => {
    setStudentList((prev) =>
      prev.map((s) => (s.reg_id === id ? { ...s, statusflag: flag } : s)),
    )
  }

  // ---------------------------------------------------
  // 4️⃣ SAVE ATTENDANCE
  // ---------------------------------------------------
  const handleSave = async () => {
    if (!eventId) {
      toast.error('Please select event')
      return
    }

    const pending = studentList.some((s) => s.statusflag === '0')
    if (pending) {
      toast.error('Please mark all students')
      return
    }
    setLoading1(true)

    const payload = {
      branch_id: parseInt(storedBranchId),
      year: BoardingYear,
      attendance_date: date.format('YYYY-MM-DD'),
      event_id: eventId,
      attendanceList: studentList.map((s) => ({
        reg_id: parseInt(s.reg_id),
        status: parseInt(s.statusflag),
      })),
    }

    try {
      const res = await axios.post(SaveStudentEventAttendance, payload)
      if (res.data === 'ATTENDANCESAVED') {
        toast.success('Attendance saved successfully!')
        fetchStudents() // refresh
        setSaveDisabled(true);
      }
    } catch (err) {
      console.error(err)
      toast.error('Failed to save attendance')
    }
    setLoading1(false)
  }

  // ---------------------------------------------------
  // TABLE COLUMNS
  // ---------------------------------------------------
  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => index + 1,
      width: 70,
    },
    { title: 'Name', dataIndex: 'full_name' },
    { title: 'Room No', dataIndex: 'room', width: 100 },
    { title: 'Bed No', dataIndex: 'bed', width: 100 },

    {
      title: 'Attendance',
      dataIndex: 'statusflag',
      align: 'center',
      render: (flag, record) => (
        <Space>
          <Button
            type={flag === '1' ? 'primary' : 'default'}
            onClick={() => updateStatus(record.reg_id, '1')}
          >
            P
          </Button>

          <Button
            danger
            type={flag === '2' ? 'primary' : 'default'}
            onClick={() => updateStatus(record.reg_id, '2')}
          >
            A
          </Button>
        </Space>
      ),
    },
  ]

  const exportToExcel = () => {
    if (studentList.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const selectedEvent = eventList.find(
      (e) => String(e.id) === String(eventId),
    )

    const excelData = studentList.map((student, index) => ({
      'Sr No': index + 1,
      'Student Name': student.full_name,
      'Room No': student.room || '-',
      'Bed No': student.bed || '-',
      Event: selectedEvent?.event_name || '-',
      Date: date.format('DD-MM-YYYY'),
      Attendance:
        student.statusflag === '1'
          ? 'Present'
          : student.statusflag === '2'
          ? 'Absent'
          : 'Not Marked',
    }))

    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 35 },
      { wch: 12 },
      { wch: 12 },
      { wch: 30 },
      { wch: 15 },
      { wch: 15 },
    ]

    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance')

    XLSX.writeFile(
      workbook,
      `Event_Attendance_${selectedEvent?.event_name || 'Event'}_${date.format(
        'YYYY-MM-DD',
      )}.xlsx`,
    )
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2 pb-3"></div>
        <div className="col-12 col-md-8 pb-3">
          <div className="header-row">
            <h2 className="page-title">Event Attendance</h2>
          </div>

          {/* Filters */}
          <div
            className="d-flex justify-content-between align-items-center my-3 flex-wrap"
            style={{ gap: '15px' }}
          >
            <div className="d-flex gap-3 flex-wrap">
              <DatePicker
                value={date}
                format="DD-MM-YYYY"
                onChange={(d) => setDate(d)}
              />

              <Select
                value={eventId}
                placeholder="Select Event"
                allowClear
                style={{ width: 250 }}
                onChange={(value) => setEventId(value)}
              >
                <Option value="" disabled>
                  Select Event
                </Option>

                {eventList?.map((e) => (
                  <Option key={e.id} value={e.id}>
                    {e.event_name}
                  </Option>
                ))}
              </Select>
            </div>

            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={studentList}
            rowKey="reg_id"
            loading={loading}
            pagination={{ pageSize: 10 }}
            bordered
            rowClassName={(record) =>
              record.disabledRow ? 'locked-attendance-row' : ''
            }
            scroll={{ x: 'max-content' }}
            className="shadow border rounded"
          />

          <div className="text-center mt-3">
            <Button
              className="addButton"
              loading={loading1}
              onClick={handleSave}
              disabled={saveDisabled}
            >
              Save Attendance
            </Button>
          </div>
          <div className="col-12 col-md-2 pb-3"></div>
        </div>
      </div>
    </div>
  )
}
